import { LANDING_CARDS } from "../constants/landingCards";
import { IO_CARDS } from "../constants/ioCards";
import { SUPPLY_PLANNING_MENU } from "../constants/supplyPlanningMenu";

export async function landingCardsLoader() {
  return LANDING_CARDS;
}

export async function ioCardsLoader() {
  return IO_CARDS;
}

export async function supplyPlanningMenuLoader() {
  return SUPPLY_PLANNING_MENU;
}
